import React, { Component } from 'react'
import Already from './Already'
import Wait from './Wait'
import Record from './Record'
import { Tabs } from 'hljd'
import { HeaderView } from '@merchant-backend/common-components'
import { JUKE_PATH_A } from '@constant'

const TabPane = Tabs.TabPane

export default class extends Component {
  render() {
    return (
      <HeaderView
        title="旧版聚客宝"
        header={[
          <a style={{ color: '#333', marginRight: 5 }} href={JUKE_PATH_A}>
            聚客宝
          </a>,
          '旧版聚客宝'
        ]}
      >
        <Tabs defaultActiveKey="1" onChange={this.callback}>
          <TabPane tab="已上线" key="1">
            <Already />
          </TabPane>
          <TabPane tab="待上线" key="2">
            <Wait />
          </TabPane>
          <TabPane tab="申请记录" key="3">
            <Record />
          </TabPane>
        </Tabs>
      </HeaderView>
    )
  }
}
